import React, {Component} from 'react'
import {withTranslation} from 'react-i18next';
import {Field} from 'redux-form'
import {checkbox} from '../Form/checkbox'

// Decorate the class.
@withTranslation()
export default class WorkshopRequest extends Component {

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		const {t} = this.props;

		return (
      <fieldset>
        <h3>{t('application.applicant.workshopRequest')}</h3>
        <Field name='workshopDesired'
               component={checkbox}
               label={t('application.applicant.workshopRequestLabel')}/>
        <p className="help-block">{t('application.applicant.workshopDesignatedUse')}</p>
      </fieldset>
		)
	}
}
